var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-icon-picker-item.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
let SdsIconPickerItem = (() => {
    var _SdsIconPickerItem_value_accessor_storage, _SdsIconPickerItem_selected_accessor_storage, _SdsIconPickerItem_name_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-icon-picker-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    var SdsIconPickerItem = _classThis = class extends _classSuper {
        get value() { return __classPrivateFieldGet(this, _SdsIconPickerItem_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsIconPickerItem_value_accessor_storage, value, "f"); }
        get selected() { return __classPrivateFieldGet(this, _SdsIconPickerItem_selected_accessor_storage, "f"); }
        set selected(value) { __classPrivateFieldSet(this, _SdsIconPickerItem_selected_accessor_storage, value, "f"); }
        get name() { return __classPrivateFieldGet(this, _SdsIconPickerItem_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsIconPickerItem_name_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-tooltip basic position="down">
                <div slot="trigger" class="${this.getClasses()}">
                    <sds-icon size="24" name="${this.value}"></sds-icon>
                </div>
                <div slot="text">${this.name}</div>
            </sds-tooltip>
        `;
        }
        getClasses() {
            return classMap({
                'sds-icon-picker-item': true,
                'sds-icon-picker-item--selected': this.selected,
            });
        }
        constructor() {
            super(...arguments);
            _SdsIconPickerItem_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, void 0));
            _SdsIconPickerItem_selected_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _selected_initializers, false)));
            _SdsIconPickerItem_name_accessor_storage.set(this, (__runInitializers(this, _selected_extraInitializers), __runInitializers(this, _name_initializers, false)));
            __runInitializers(this, _name_extraInitializers);
        }
    };
    _SdsIconPickerItem_value_accessor_storage = new WeakMap();
    _SdsIconPickerItem_selected_accessor_storage = new WeakMap();
    _SdsIconPickerItem_name_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsIconPickerItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _value_decorators = [property()];
        _selected_decorators = [property({ type: Boolean })];
        _name_decorators = [property()];
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(_classThis, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsIconPickerItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsIconPickerItem = _classThis;
})();
export { SdsIconPickerItem };
